/**
 * App header: the brand, the "platform" tag, and auth-aware navigation.
 * Signed out shows "Sign in"; signed in shows "Dashboard" + "Sign out".
 */
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@nuff/ui/react';

import { useAuth } from './auth/context';

export function Header(): React.JSX.Element {
  const { status, signOut } = useAuth();
  const navigate = useNavigate();

  function handleSignOut(): void {
    signOut();
    void navigate('/signin');
  }

  return (
    <header className="app__bar">
      <a className="brand" href="https://nuffsaid.cloud">
        nuffsaid<span className="brand__dot">.cloud</span>
      </a>
      <span className="app__tag">platform</span>
      <nav className="app__nav" aria-label="Account">
        {status === 'signedIn' ? (
          <>
            <Link className="app__nav-link" to="/app">
              Dashboard
            </Link>
            <Button variant="secondary" size="sm" onClick={handleSignOut}>
              Sign out
            </Button>
          </>
        ) : status === 'signedOut' ? (
          <Link className="app__nav-link" to="/signin">
            Sign in
          </Link>
        ) : null}
      </nav>
    </header>
  );
}
